<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" *ngIf="!activeAddModal; else addTitle">
      {{ "EditDrugTitle" | translate }}
      <span class="ms-2" *ngIf="thisValue">
        {{ thisValue.persianName }}
      </span>
    </h5>
    <ng-template #addTitle>
      <h5 class="modal-title">
        {{ "AddDrugTitle" | translate }}
      </h5>
    </ng-template>
    <button
      type="button"
      class="btn-close"
      (click)="closeModal()"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body" *ngIf="thisValue">
    <div class="row input-box finance-box ms-1 p-2 mb-2">
      <div class="input-box-title-box px-2">
        <span>{{ "RequiredInformation" | translate : "" }}</span>
      </div>
      <div class="row" *ngIf="productType == 0 || productType == null">
        <div class="col-12 col-md-6 p-2 py-0" *ngIf="productType == null">
          <div class="edit-form">
            <label class="form-label" for="drug-product-type">
              {{ "ProductType" | translate }}
            </label>
            <div
              class="validation-alert-input"
              *ngIf="thisValue.productTypeHint != null"
            >
              <p>
                {{ thisValue.productTypeHint | translate }}
              </p>
            </div>

            <select
              class="form-select"
              [ngClass]="{
                'is-invalid': thisValue.nameHint != null
              }"
              (change)="getGenericList()"
              [(ngModel)]="thisValue.productType"
            >
              <option [ngValue]="undefined">
                {{ "select item" | translate }}
              </option>
              <option
                *ngFor="let type of this.productTypeList"
                [value]="type.value"
              >
                {{ type.name | translate }}
              </option>
            </select>
          </div>
        </div>
        <div
          class="p-2 py-0"
          [ngClass]="{
            'col-12 col-md-6': productType == null,
            'col-12': productType == 0
          }"
        >
          <div class="edit-form">
            <label class="form-label" for="drug-DrugGeneric">
              {{ "DrugGeneric" | translate }}
            </label>
            <div class="dropdown-background">
              <div
                class="validation-alert-pc-modal"
                *ngIf="thisValue.drugGenericHint != null"
              >
                <p>
                  {{ thisValue.drugGenericHint }}
                </p>
              </div>

              <app-drop-down-paging
                [data]="genericDropDown"
                (ngModelValueChange)="thisValue!.drugGenericId = $event.id"
              >
              </app-drop-down-paging>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-name">
              {{ "EnglishName" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisValue.persianNameHint != null"
            >
              <p>
                {{ thisValue.nameHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-name"
              autocomplete="off"
              class="form-control go-to-next"
              [ngClass]="{
                'is-invalid': thisValue.nameHint != null
              }"
              [(ngModel)]="thisValue!.name"
              [attr.placeholder]="'EnglishName' | translate"
            />
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-6 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-farsi-name">
              {{ "persianName" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisValue.persianNameHint != null"
            >
              <p>
                {{ thisValue.persianNameHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-farsi-name"
              autocomplete="off"
              class="form-control go-to-next"
              [ngClass]="{
                'is-invalid': thisValue.persianNameHint != null
              }"
              [(ngModel)]="thisValue!.persianName"
              [attr.placeholder]="'persianName' | translate"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 col-lg-4 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-package-count">
              {{ "drugPackageCount" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisValue.drugPackageHint != null"
            >
              <p>
                {{ thisValue.drugPackageHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-package-count"
              class="form-control go-to-next"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': this.thisValue.drugPackageHint != null
              }"
              [(ngModel)]="thisValue!.drugPackageCount"
              [attr.placeholder]="'drugPackageCount' | translate"
              mask="separator.0"
              thousandSeparator=","
            />
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-4 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-DrugForm">
              {{ "DrugForm" | translate }}
            </label>
            <div class="dropdown-background">
              <div
                class="validation-alert-pc-modal"
                *ngIf="thisValue.drugFormHint != null"
              >
                <p>
                  {{ thisValue.drugFormHint }}
                </p>
              </div>

              <app-drop-down-paging
                [data]="drugFormDropDown"
                (ngModelValueChange)="thisValue!.drugFormId = $event.id"
              >
              </app-drop-down-paging>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-4 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-creator-company">
              {{ "creatorCompanyName" | translate }}
            </label>
            <div class="dropdown-background">
              <div
                class="validation-alert-pc-modal"
                *ngIf="thisValue!.creatorCompanyHint != null"
              >
                <p>
                  {{ thisValue!.creatorCompanyHint }}
                </p>
              </div>

              <app-drop-down-paging
                [data]="createCompanyDropDown"
                (ngModelValueChange)="thisValue!.creatorCompanyId = $event.id"
              >
              </app-drop-down-paging>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-md-12 col-lg-6 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-buy-price">
              {{ "BuyPrice" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisValue.buyPriceHint != null"
            >
              <p>
                {{ thisValue.buyPriceHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-buy-price"
              class="form-control go-to-next"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': thisValue.buyPriceHint != null
              }"
              [(ngModel)]="thisValue!.buyPrice"
              [attr.placeholder]="'BuyPrice' | translate"
              mask="separator.0"
              thousandSeparator=","
            />

            <span class="set-position-rial-prefix">
              {{ "Rial" | translate }}
            </span>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-6 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-sales-price">
              {{ "SalesPrice" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisValue.costHint != null"
            >
              <p>
                {{ thisValue.costHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-sales-price"
              class="form-control go-to-next"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': thisValue.costHint != null
              }"
              [(ngModel)]="thisValue!.sellPrice"
              [attr.placeholder]="'EnglishName' | translate"
              mask="separator.0"
              thousandSeparator=","
            />

            <span class="set-position-rial-prefix">
              {{ "Rial" | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row input-box drug-information-box mt-3 ms-1 p-2 mb-2">
      <div class="input-box-title-box px-2">
        <div class="shadow-input-box">
          <span>{{ "FurtherInformation" | translate : "" }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 col-lg-4 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-flavor">
              {{ "flavor" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisValue.flavorHint != null"
            >
              <p>
                {{ thisValue.flavorHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-flavor"
              class="form-control go-to-next"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': thisValue.flavorHint != null
              }"
              [(ngModel)]="thisValue!.flavor"
              [attr.placeholder]="'flavor' | translate"
            />
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-4 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-DrugUsage">
              {{ "DrugUsage" | translate }}
            </label>
            <div class="dropdown-background">
              <div
                class="validation-alert-pc-modal"
                *ngIf="thisValue.drugUsageHint != null"
              >
                <p>
                  {{ thisValue.drugUsageHint }}
                </p>
              </div>

              <app-drop-down-paging
                [data]="drugUsageDropDown"
                (ngModelValueChange)="thisValue!.drugUsageId = $event.id"
              >
              </app-drop-down-paging>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-4 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-license-company">
              {{ "licenseCompanyName" | translate }}
            </label>
            <div class="dropdown-background">
              <div
                class="validation-alert-pc-modal"
                *ngIf="thisValue.licenseCompanyHint != null"
              >
                <p>
                  {{ thisValue.licenseCompanyHint }}
                </p>
              </div>

              <app-drop-down-paging
                [data]="companyDropDown"
                (ngModelValueChange)="thisValue!.licenseCompanyId = $event.id"
              >
              </app-drop-down-paging>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-Country">
              {{ "Country" | translate }}
            </label>
            <div class="dropdown-background">
              <div
                class="validation-alert-pc-modal"
                *ngIf="thisValue.countryHint != null"
              >
                <p>
                  {{ thisValue.countryHint }}
                </p>
              </div>

              <app-drop-down-paging
                [data]="countryDropDown"
                (ngModelValueChange)="thisValue!.countryId = $event.id"
              >
              </app-drop-down-paging>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-6 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-keeping-type">
              {{ "keepingTypeName" | translate }}
            </label>
            <div class="dropdown-background">
              <div
                class="validation-alert-pc-modal"
                *ngIf="thisValue.keepingTypeHint != null"
              >
                <p>
                  {{ thisValue.keepingTypeHint }}
                </p>
              </div>

              <app-drop-down-paging
                [data]="keepingTypeDropDown"
                (ngModelValueChange)="thisValue!.keepingTypeId = $event.id"
              ></app-drop-down-paging>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row input-box stock-box mt-3 ms-1 p-2 mb-2">
      <div class="input-box-title-box px-2">
        <div class="shadow-input-box">
          <span>{{ "BarcodeInformation" | translate : "" }}</span>
        </div>
      </div>
      <div class="set-modal">
        <div class="col-12 mt-3">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">{{ "ERX" | translate }}</th>
                <th scope="col">{{ "IRC" | translate }}</th>
                <th scope="col">{{ "GTN" | translate }}</th>
                <th scope="col">{{ "Barcode" | translate }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody id="rows">
              <tr
                *ngFor="let selectDrug of thisValue!.drugCodes; let i = index"
              >
                <!-- <td>{{ i + 1 }}</td> -->
                <td>{{ selectDrug.erxCode }}</td>
                <td>{{ selectDrug.irc | dataType : "" }}</td>
                <td>{{ selectDrug.gtn | dataType : "" }}</td>
                <td>{{ selectDrug.barCode | dataType : "" }}</td>
                <td class="d-flex justify-content-evenly align-items-center">
                  <button
                    type="button"
                    class="btn btn-icon btn-outline-primary go-to-next"
                    (click)="editDrugCode(selectDrug, i)"
                  >
                    <i class="fas fa-edit"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-ERX">
              {{ "ERX" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisBarcodeValue.ERXHint != null"
            >
              <p>
                {{ thisBarcodeValue.ERXHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-ERX"
              class="form-control go-to-next"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': thisBarcodeValue.ERXHint != null
              }"
              [(ngModel)]="thisBarcodeValue!.erxCode"
              [attr.placeholder]="'ERX' | translate"
            />
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-IRC">
              {{ "IRC" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisBarcodeValue.IRCHint != null"
            >
              <p>
                {{ thisBarcodeValue.IRCHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-IRC"
              class="form-control go-to-next"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': thisBarcodeValue.IRCHint != null
              }"
              [(ngModel)]="thisBarcodeValue!.irc"
              [attr.placeholder]="'IRC' | translate"
            />
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 p-2 py-0">
          <div class="edit-form">
            <label class="form-label" for="drug-GTN">
              {{ "GTN" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisBarcodeValue.GTNHint != null"
            >
              <p>
                {{ thisBarcodeValue.GTNHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-GTN"
              class="form-control go-to-next"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': thisBarcodeValue.GTNHint != null
              }"
              [(ngModel)]="thisBarcodeValue!.gtn"
              [attr.placeholder]="'GTN' | translate"
            />
          </div>
        </div>
        <div
          class="col-12 col-md-6 col-lg-3 p-2 py-0"
        >
          <div class="edit-form">
            <label class="form-label" for="drug-Barcode">
              {{ "Barcode" | translate }}
            </label>
            <div
              class="validation-alert-pc-modal"
              *ngIf="thisBarcodeValue.BarcodeHint != null"
            >
              <p>
                {{ thisBarcodeValue.BarcodeHint }}
              </p>
            </div>

            <input
              type="text"
              id="drug-Barcode"
              class="form-control go-to-next"
              autocomplete="off"
              [ngClass]="{
                'is-invalid': thisBarcodeValue.BarcodeHint != null
              }"
              [(ngModel)]="thisBarcodeValue!.barCode"
              [attr.placeholder]="'Barcode' | translate"
            />
          </div>
          <div class="button-box pt-4">
            <button
              type="button"
              class="btn btn-icon btn-outline-success go-to-next p-1"
              (click)="addNewDrugCode(thisValue.id)"
            >
              <i class="far fa-save"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer" *ngIf="thisValue">
    <div class="col-12 d-flex justify-content-evenly">
      <button
        class="btn btn-label-secondary btn-prev go-to-next"
        (click)="clearEditItem()"
      >
        <span class="d-sm-inline-block d-none"> {{ "Clear" | translate }}</span>
      </button>
      <button class="btn btn-primary btn-next go-to-next" (click)="submit()">
        <span class="d-sm-inline-block d-none me-sm-1">
          {{ "Submit" | translate }}</span
        >
      </button>
    </div>
  </div>

  <app-loading-panel *ngIf="loadingModal"></app-loading-panel>
</div>
